export enum ExternalTestState {
  Draft = "draft",
  Completed = "completed",
  Included = "included",
}
